import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    [
      face.u.two,
      face.m.one,
      face.u.two,
    ],
  ],
  name: 'Cycle',
};
